module.exports = __webpack_public_path__ + "static/media/backArrow.4f34ee32.svg";